<form [formGroup]="form">
  <div class="quiz-block">
    <mat-radio-group
      aria-label="Select an option"
      ngDefaultControl
      formControlName="boolChoice"
    >
      <mat-radio-button value="true" [checked]="isChecked(true)"
        >True</mat-radio-button
      >
      <mat-radio-button value="false" [checked]="isChecked(false)"
        >False</mat-radio-button
      >
    </mat-radio-group>
  </div>
</form>
